module.exports = __webpack_public_path__ + "img/mobilelab_parked.d75129df.svg";